import React, { useEffect, useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import FileAdder from "../../../assets/FileAdder.svg";
import { Button, DialogFooter } from "@material-tailwind/react";

export type FileItem = {
  name: string;
  size: number;
};

interface FileUploadPageProps {
  onSend: (files: File[]) => void;
  handleChange: (e: any) => void;
  values: { [key: string]: any };
}

export function truncateFileName(str: string, n: number, m: number): string {
  if (str.length <= n + m) {
    return str;
  }
  const start = str.substring(0, n);
  const end = str.substring(str.length - m);
  return `${start}...${end}`;
}

const ConvertToFileItem = (files: File[]) => {
  const itemFiles = files.map((file) => ({
    name: truncateFileName(file.name, 6, 6),
    size: file.size / 1000000, // convert bytes to MB
  }));

  return itemFiles;
};

const ProductionFileUpload: React.FC<FileUploadPageProps> = ({
  onSend,
  handleChange,
  values,
}) => {
  const [files, setFiles] = useState<FileItem[]>(
    ConvertToFileItem(values.productionFileIds),
  );
  const [filesState, setFilesState] = useState<File[]>(
    values.productionFileIds,
  );

  const onDrop = (acceptedFiles: File[]) => {
    const newFiles = acceptedFiles.map((file) => ({
      name: truncateFileName(file.name, 6, 6),
      size: file.size / 1000000, // convert size to Mo
    }));
    const newFilesState = [...filesState, ...acceptedFiles];
    setFiles((prev) => [...prev, ...newFiles]);
    setFilesState(newFilesState);
    onSend(newFilesState);
    handleChange("productionFileIds");
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "image/*": [".jpeg", ".png", ".jpg"],
      "application/pdf": [".pdf"],
      "application/docx": [".docx"],
    },
    noClick: true, // Empêche le clic sur la zone de drop de déclencher l'input
  });

  const handleFileRemove = (index: number) => {
    const newFiles = [...files];
    const newStateFiles = [...filesState];
    newFiles.splice(index, 1);
    newStateFiles.splice(index, 1);
    setFilesState(newStateFiles);
    setFiles(newFiles);
    onSend(newStateFiles);
    handleChange("productionFileIds");
  };

  const handleFileReplace = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number,
  ) => {
    if (event.target.files) {
      const newFile = {
        name: event.target.files[0].name,
        size: event.target.files[0].size / 1000000, // convert size to Mo
      };
      const newFileState = event.target.files[0];
      const newFiles = [...files];
      const newStateFiles = [...filesState];
      newFiles[index] = newFile;
      newStateFiles[index] = newFileState as File;
      setFilesState(newStateFiles);
      setFiles(newFiles);
      onSend(newStateFiles);
      handleChange("productionFileIds");
    }
  };
  const inputDragRef = useRef<HTMLInputElement>(null);

  return (
    <section className="flex flex-col items-center justify-center  w-full h-full bg-white">
      <div {...getRootProps()} className="mb-4">
        <input {...getInputProps()} ref={inputDragRef} />

        {isDragActive ? (
          <div className="flex flex-col w-full items-center justify-center space-y-5 mb-10 mt-15">
            <img src={FileAdder} alt="FileAdder" className="w-6 h-6 " />
            <p className="text-black text-lg font-semi-bold font-['Open Sans'] leading-none mb-10">
              Glisser pour téléverser un fichier
            </p>
          </div>
        ) : (
          <div className="flex flex-col w-full items-center justify-center space-y-10">
            <img src={FileAdder} alt="FileAdder" className="w-10 h-10 " />
            <p className="text-black text-lg font-semi-bold font-['Open Sans'] leading-none mb-10">
              Téléverser des images ou des fichiers PDF, en{" "}
              <label
                className="text-[#131CC9] w-full text-lg font-['Open Sans'] leading-none cursor-pointer"
                onClick={(e) => e.stopPropagation()} // Empêche la propagation du clic
              >
                Chargeant
                <input
                  type="file"
                  className="hidden"
                  accept=".pdf,.jpg,.jpeg,.png,.docx"
                  multiple
                  onChange={(event) =>
                    onDrop(
                      event.target.files ? Array.from(event.target.files) : [],
                    )
                  }
                />
              </label>
            </p>
          </div>
        )}
      </div>
      <ul className="fix w-2/3 h-full rounded-lg border-t border-r border-l border-dashed border-[#858585] overflow-x-hidden overflow-y-auto scrollbar scrollbar-track-rounded-lg scrollbar-thumb-gray-500 scrollbar-track-gray-200 hover:scrollbar-thumb-gray-600 focus:scrollbar-thumb-gray-600">
        <div className="flex flex-col w-full space-y-4 mt-5 mb-5 mr-5 ml-5">
          {files.map((file, index) => (
            <li
              key={index}
              className="flex flex-row w-full h-full items-center justify-between mb-4 text-black text-lg"
            >
              <span className="flex justify-center items-center">
                {index + 1}.{" "}
              </span>
              <a
                href="#"
                download
                className="flex w-full justify-start items-center"
              >
                {file.name}
              </a>
              <span className="flex w-full justify-center items-center">
                {file.size.toFixed(2)}Mo
              </span>
              <button
                onClick={() => handleFileRemove(index)}
                className="flex w-full justify-center items-center"
              >
                X
              </button>
              <label className="flex w-full justify-center items-center ">
                Modifier
                <input
                  type="file"
                  className="hidden flex justify-center items-center"
                  onChange={(event) => handleFileReplace(event, index)}
                />
              </label>
            </li>
          ))}
        </div>
      </ul>
      {/* <DialogFooter className="flex flex-row items-end justify-end w-2/3">
        <Button
          onClick={() => onSend(filesState)}
          color="green"
          variant="gradient"
          className="bg-[#E3B505] text-[#131CC9]"
        >
          Envoyer
        </Button>
      </DialogFooter> */}
    </section>
  );
};

export default ProductionFileUpload;
